/* esm.sh - react-universal-interface@0.6.2 */
export * from "/*react-universal-interface@0.6.2/esnext/react-universal-interface.mjs";
export { default } from "/*react-universal-interface@0.6.2/esnext/react-universal-interface.mjs";
